<template>
  <router-view/>
</template>
<script setup>

</script>
<style lang="scss">
body {
  padding: 0;
  margin: 0;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: linear-gradient(to right, #f5f5f5, #e8e8e8);
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(to right, #a1a1a1, #6b6b6b);
    border-radius: 5px;
    box-shadow: inset 0 0 6px rgba(30, 29, 29, 0.3); /* 阴影 */
  }

  html,
  body {
    height: 100%;
    overflow: hidden;
  }

  #app {
    //border: 1px solid red;
    //width: calc(100vw - 20px);
    height: 100%;
    min-width: 950px;
    background: #ffffff;
    overflow: hidden;
    overflow-x: auto;

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: linear-gradient(to right, #f5f5f5, #e8e8e8);
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(to right, #a1a1a1, #6b6b6b);
      border-radius: 5px;
      box-shadow: inset 0 0 6px rgba(61, 61, 61, 0.3); /* 阴影 */
    }
  }

  .x-red {
    color: #ff0000;
  }
}
</style>
